module.exports = __webpack_public_path__ + "img/noteklava.15f2c2d5.png";